var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-principal"},[_c('navtop'),_c('bartools'),_c('div',{class:['domHtml', !_vm.hideNav ? 'pleft' : '']},[_c('article',{staticClass:"siteHtml"},[_c('navhead'),_c('viewPage')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }